import * as d from "react";
import { s as l, c as h } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { j as p } from "./jsx-runtime-3tyXYecC.mjs";
import { s as B, a as N } from "./tss-DN0acMKN.mjs";
import { e as R } from "./extendSxProp-BhQEuuTD.mjs";
function F(r = {}) {
  const {
    themeId: s,
    defaultTheme: m,
    defaultClassName: t = "MuiBox-root",
    generateClassName: a
  } = r, n = l("div", {
    shouldForwardProp: (e) => e !== "theme" && e !== "sx" && e !== "as"
  })(B);
  return /* @__PURE__ */ d.forwardRef(function(c, x) {
    const o = N(m), {
      className: f,
      component: i = "div",
      ...u
    } = R(c);
    return /* @__PURE__ */ p.jsx(n, {
      as: i,
      ref: x,
      className: h(f, a ? a(t) : t),
      theme: s && o[s] || o,
      ...u
    });
  });
}
export {
  F as c
};
//# sourceMappingURL=createBox-58X037dC.mjs.map
